import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";

/**
 * Light green section marker used by the delivery & payment dialog.
 */
export const DietInfoBadge = ({
  icon,
  children,
}: {
  icon: ReactNode;
  children: ReactNode;
}) => (
  <Badge
    className="gap-1.5 rounded-full border-0 bg-brand-green-50 px-2 py-1.5 font-medium text-brand-green-500 text-sm"
    variant="outline"
  >
    {icon}
    {children}
  </Badge>
);
